<template>
    <b-dropdown position="is-bottom-left">
        <a class="navbar-item" slot="trigger">
            <b-icon icon="user-circle">

            </b-icon>
            <span class="is-hidden-mobile">{{ $auth.user().name }}</span>
            <b-icon icon="angle-down"></b-icon>
        </a>

        <b-dropdown-item custom>
            Usuario <b>{{ $auth.user().email }}</b>
        </b-dropdown-item>
        <hr class="dropdown-divider">
        <b-dropdown-item value="home" has-link>
            <router-link :to="{name:'Home'}">
                <b-icon icon="home"></b-icon>
                Inicio
            </router-link>
        </b-dropdown-item>
        <hr class="dropdown-divider">
        <b-dropdown-item value="settings" has-link>
            <router-link :to="{name:'Profile'}">
                <b-icon icon="cog"></b-icon>
                Perfil
            </router-link>
        </b-dropdown-item>
        <b-dropdown-item has-link>
            <a @click="logout">
                <b-icon icon="sign-out-alt"></b-icon>
                Cerrar sesión
            </a>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
    export default {
        name: "ProfileNav",
        data() {
            return {

            }
        },
        computed: {
            device() {
                return this.$store.state.device;
            },
        },
        methods: {
            logout() {
                this.$dialog.confirm({
                    title: 'Cerrar sesión',
                    message: '¿Estas seguro de salir?',
                    confirmText: 'Si, salir',
                    cancelText: 'No, permanecer aqui',
                    onConfirm: () => {
                        this.$loader.show();
                        this.$auth.logout({
                            makeRequest: true,
                            success(response) {
                                let data = response.data;
                                this.$loader.hide();
                                this.$notify.open(data.message);
                                if(this.device){
                                    this.device.destroy();
                                }
                            },
                            error() {
                                this.$loader.hide()
                            }
                        })
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
